import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { appConfigService } from '@/providers/services/app/app-config';

@Component({
    name: 'activity-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'mc-icon': MCIcon,
    },
})

export default class ActivityCard extends Vue {

    // --------------------------------------------------------------------------
    // Properties
    @Prop()
    private content: any;

    // ---------------------------------------------------------------------------
    // Actions

    private openPullOut() {
        this.$emit('openPullOut', this.content);
    }

    private onPlay(content: any) {
        if (content.type === 'collection') {
            const playerURL = `${appConfigService.getApiUrl()}/player/${content.id}?source=rgo`;
            window.open(playerURL, 'rgo_player');
        } else if (content.type === 'assessment') {
            const playerURL = `${appConfigService.getApiUrl()}/player/${content.id}?source=rgo`;
            window.open(playerURL, 'rgo_player');
        } else if (content.type === 'resource') {
            const playerURL = `${appConfigService.getApiUrl()}/content/resources/play/${content.id}?source=rgo`;
            window.open(playerURL, 'rgo_player');
        } else if (content.type === 'question') {
            const playerURL = `${appConfigService.getApiUrl()}/content/questions/play/${content.id}?source=rgo`;
            window.open(playerURL, '_blank');
        } else if (content.type === 'offline-activity') {
            const playerURL = `${appConfigService.getApiUrl()}/player-offline-activity/${content.id}?isPreview=true&role=teacher`;
            window.open(playerURL, '_blank');
        }
    }
}

